/** @type {Map<string, AbortController>} */
const pendingLoads = new Map();

/** @type {Set<string>} */
const closeAbortWired = new Set();

/**
 * @param {HTMLElement} popup
 */
function wireCloseAbort(popup) {
  if (!(popup instanceof HTMLDialogElement) || closeAbortWired.has(popup.id)) {
    return;
  }
  closeAbortWired.add(popup.id);
  popup.addEventListener('close', () => pendingLoads.get(popup.id)?.abort());
}

/**
 * @param {HTMLElement} popup
 * @returns {AbortController}
 */
function beginLoad(popup) {
  pendingLoads.get(popup.id)?.abort();
  const controller = new AbortController();
  pendingLoads.set(popup.id, controller);
  wireCloseAbort(popup);
  return controller;
}

/**
 * @param {HTMLElement} popup
 * @param {AbortController} controller
 */
function endLoad(popup, controller) {
  if (pendingLoads.get(popup.id) === controller) {
    pendingLoads.delete(popup.id);
  }
}

export { beginLoad, endLoad };
